/**
 * Created by anatoly on 06.05.2025
 */

const Backpack = function (slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.customIcon = BackpackButton;
    this.extraBarWeight = 100005;

    this.openedSpace = cleverapps.meta.getExtra("space") || 0;
    this.slots = [];
    this.marks = [];

    this.load();

    this.logEvents();

    cleverapps.user.on("recheckAvailable", () => {
        if (this.isAvailable()) {
            this.trigger("show");
        }
    }, this);
};

Backpack.prototype = Object.create(cleverapps.EventEmitter.prototype);
Backpack.prototype.constructor = Backpack;

Backpack.prototype.load = function () {
    const data = this.slot.load("storage") || {};
    data.units = data.units || "";
    const details = data.details || {};
    for (let i = 0, index = 0; ; index++) {
        if (data.units[i] === undefined) {
            break;
        }
        if (data.units[i] === " ") {
            this.slots.push(undefined);
            i++;
            continue;
        }

        const unit = Object.assign(FlatMapSaver.expandUnit(data.units.substring(i, i + 3)), details[index]);
        if (unit.code !== "thirdelement") {
            this.slots.push(Families.processUnknown(unit, Merge2.current.families));
        }

        i += 3;
    }
};

Backpack.prototype.save = function () {
    let units = "";
    const details = {};

    for (let index = 0; index < this.slots.length; index++) {
        const unit = this.slots[index];
        const info = unit && unit.code === "unknown" ? unit._data : unit;
        units += info ? FlatMapSaver.compactUnit(info) : Backpack.EMPTY_CELL;

        for (const key in info) {
            if (key !== "code" && key !== "stage") {
                details[index] = details[index] || {};
                details[index][key] = info[key];
            }
        }
    }

    this.slot.save("storage", {
        units,
        details
    });

    cleverapps.meta.setExtra("space", this.openedSpace);
    cleverapps.meta.save();
};

Backpack.prototype.destructor = function () {
    runCleaners(this);
};

Backpack.prototype.getUnits = function () {
    return this.slots.filter((unit) => unit);
};

Backpack.prototype.countUnits = function (key) {
    return this.getUnits().filter((unit) => Unit.GetKey(unit) === key).length;
};

Backpack.prototype.pickUnits = function (amounts) {
    const indexes = [];

    this.slots.forEach((unit, index) => {
        if (!unit || Stock.IGNORES_STOCK.includes(unit.code)) {
            return;
        }

        const key = Unit.GetKey(unit);
        if (amounts[key] > 0) {
            amounts[key] -= 1;
            indexes.push(index);
        }
    });

    return indexes;
};

Backpack.prototype.setMarks = function (indexes) {
    const marks = [];
    indexes.forEach((index) => {
        marks[index] = true;
    });

    if (marks.length === this.marks.length && marks.every((mark, index) => mark === this.marks[index])) {
        return;
    }

    this.marks = marks;
    this.trigger("onUpdateMarks");
};

Backpack.prototype.isMarked = function (index) {
    return Boolean(this.marks[index]);
};

Backpack.prototype.getStorageSize = function () {
    return Backpack.BASE_SIZE + this.openedSpace;
};

Backpack.prototype.isFull = function () {
    return this.findFreeSlot() === undefined;
};

Backpack.prototype.findFreeSlot = function () {
    for (let i = 0; i <= this.getStorageSize(); i++) {
        if (this.isFreeSlot(i)) {
            return i;
        }
    }
};

Backpack.prototype.insert = function (index, unit) {
    const slots = this.slots;

    slots[index] = unit.getInfo();

    this.save();
    this.trigger("onInsertUnit");
    this.trigger("onChangeUnits");

    cleverapps.metrics.logEvent(cleverapps.EVENTS.BACKPACK_INSERT);
    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.BACKPACK_USE);
};

Backpack.prototype.spawn = function (index, view) {
    if (this.isFreeSlot(index)) {
        return;
    }

    const centerCell = Merge2.current.field.getScreenCenterCell();
    const slot = Merge2.current.field.findEmptySlot(centerCell.x, centerCell.y);
    if (!slot) {
        Merge2.current.showNoSpaceHint(view);
        this.trigger("noSpace", index);
        return;
    }

    const stored = {
        ...this.slots[index],
        _fromSave: true
    };

    const unit = new Unit(stored);

    unit.setPosition(slot.x, slot.y);
    Merge2.current.field.addUnit(slot.x, slot.y, unit);
    Merge2.current.field.onAddUnit(slot.x, slot.y, unit);

    Merge2.current.field.onUnitAvailable(unit);
    unit.onAdd();

    this.clearSlot(index);
    this.trigger("onSpawnUnit", index);

    cleverapps.metrics.logEvent(cleverapps.EVENTS.BACKPACK_EXTRACT);
    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.BACKPACK_USE);
};

Backpack.prototype.takeUnit = function (index) {
    const unit = this.slots[index];
    this.clearSlot(index);
    return unit;
};

Backpack.prototype.clearSlot = function (index) {
    this.slots[index] = undefined;

    while (this.slots.length && !this.slots[this.slots.length - 1]) {
        this.slots.pop();
    }

    this.save();
    this.trigger("onClearSlot", index);
    this.trigger("onChangeUnits");
};

Backpack.prototype.getUnit = function (index) {
    return this.slots[index];
};

Backpack.prototype.isFreeSlot = function (index) {
    return index < this.getStorageSize() && !this.slots[index];
};

Backpack.prototype.unlockSlot = function () {
    if (this.getStorageSize() < Backpack.MAX_SIZE && cleverapps.user.spendHard(cleverapps.EVENTS.SPENT.BACKPACK, this.getUnlockPrice())) {
        this.openedSpace += 1;

        this.save();
        this.trigger("onUnlockSlot");
    }
};

Backpack.prototype.getUnlockPrice = function () {
    return Backpack.PRICES[this.getStorageSize()];
};

Backpack.prototype.isAvailable = function () {
    return true;
};

Backpack.prototype.logEvents = function () {
    if (!this.isAvailable()) {
        return;
    }

    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.BACKPACK_AVAILABLE);
    cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.BACKPACK_CAPACITY}_${this.getStorageSize()}`);
    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.BACKPACK_FULLNESS, {
        value: this.findFreeSlot()
    });
};

Backpack.prototype.canStoreUnit = function (unit) {
    return !unit.findComponent(Collectible)
        && !unit.findComponent(Grounded)
        && !unit.findComponent(Merge2Generator)
        && this.canAcceptUnit(unit);
};

Backpack.prototype.findUnitToStore = function () {
    if (!this.isAvailable() || this.isFull() || Merge2.current.field.countEmptySlots() > 0) {
        return;
    }

    return Merge2.current.field.listAvailableUnits().find((unit) => this.canStoreUnit(unit));
};

Backpack.prototype.canAcceptUnit = function (unit) {
    const cup = unit.findComponent(CupComponent);
    if (cup && !cup.isFull()) {
        return false;
    }

    if (unit.findComponent(ThirdElement)) {
        return false;
    }

    const locked = unit.findComponent(LockedComponent);
    if (locked && locked.isUnlocking()) {
        return false;
    }

    const generator = unit.findComponent(Merge2Generator);
    if (generator && (!generator.isFresh() || generator.isRestoring())) {
        return false;
    }

    return true;
};

Backpack.prototype.handleDropEnd = function (unit) {
    this.insert(this.findFreeSlot(), unit);
    unit.remove();

    this.trigger("addToStorage");

    return true;
};

Backpack.EMPTY_CELL = " ";

Backpack.BASE_SIZE = 5;
Backpack.MAX_SIZE = 32;

Backpack.PRICES = [0, 0, 0, 0, 0, 100, 110, 130, 160, 200, 260, 330, 450, 610, 840, 1160, 1610, 2250, 3160, 4430, 6250, 8800, 12420, 17540, 24700, 35020, 49500, 69980, 98940, 139900, 139900, 139900];
